<div class="flex flex-row flex-wrap items-center gap-1">
  <pr-query-filter-display
    icon="date_range"
    label="Searching by date"
    [values]="timestampLabel() ?? 'Unknown'"
  />
</div>
